// ** Redux Imports
import { combineReducers } from 'redux'

// ** Basic Modules Reducers
import basicReducers from '@store/reducers/basicReducer'
import { dashboardReducer } from "@cmodules/dashboard"
import { checkListReducer } from "@cmodules/checklist"
import { resourcesReducer } from "@cmodules/resources"
import { assetReducer } from "@cmodules/asset"
import { issuesReducer } from "@cmodules/issues"
import { assignmentReducer } from "@cmodules/assignment"
import { inspectionsReducer } from "@cmodules/inspections"
import { analyticsReducer } from "@cmodules/analytics"
// import { chatbotReducer } from '@chatbot/redux/reducers'


// ** Reducers Imports

const rootReducer = combineReducers({
  ...basicReducers,
  dashboard: dashboardReducer,
  checklist: checkListReducer,
  resources: resourcesReducer,
  asset: assetReducer,
  issues: issuesReducer,
  assignment: assignmentReducer,
  inspections: inspectionsReducer,
  analytics: analyticsReducer
  // chatbot: chatbotReducer
})

export default rootReducer
